import React from "react";
import { Box, Typography, CardContent, useTheme } from "@mui/material";

export default function Profile() {
  const theme = useTheme();
  const isDark = theme.palette.mode === "dark";
  // Radial alpha mask that fades the photo out at the edges. Light theme uses a
  // background-removed cutout, so the mask only needs to soften the shoulders.
  const vignette = isDark
    ? "radial-gradient(circle at 50% 45%, #000 40%, transparent 70%)"
    : "radial-gradient(circle at 50% 40%, #000 50%, transparent 72%)";
  return (
    <Box
      className="backgroundDots"
      sx={{
        width: "100%",
        minHeight: 300,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        p: 0,
        m: 0,
      }}
    >
      <Box
        sx={{
          aspectRatio: "1 / 1",
          width: "100%",
          maxWidth: 450,
          bgcolor: "background.paper",
          boxShadow: 3,
          textAlign: "center",
          p: 2,
          m: 6,
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          position: "relative",
          borderRadius: 2,
          border: "1px solid",
          borderColor: "divider",
        }}
        elevation={4}
      >
        {/* 🟢 Top-right label */}
        <Box
          sx={{
            position: "absolute",
            top: 8,
            right: 8,
            color: "primary.contrastText",
            px: 1.5,
            py: 0.5,
            borderRadius: 1,
            opacity: 0.5,
            fontSize: "0.75rem",
          }}
        >
          NILES, OH
        </Box>

        {/* 🟢 Centered image */}
        <Box
          component="img"
          src={isDark ? "/profile2d.png" : "/profile2d-cutout.png"}
          alt="Profile"
          sx={{
            width: "90%",
            mx: "auto",
            filter: "grayscale(40%) contrast(105%)",
            opacity: 0.9,
            mixBlendMode: isDark ? "lighten" : "normal",
            maskImage: vignette,
            WebkitMaskImage: vignette,
            mb: 2,
            userSelect: "none",
            pointerEvents: "none",
            display: "block",
          }}
        />

        <CardContent sx={{ pt: 0 }}>
          <Typography
            variant="caption"
            color="text.secondary"
            fontStyle="italic"
          >
            "If it can be dreamed, it can be achieved"
          </Typography>
        </CardContent>
      </Box>
    </Box>
  );
}
